import { PROJECT_SETTINGS } from "./getters.names";
import {
  projectState,
  RootState,
  RelatedProjectFilter,
  projectPageDataType,
} from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { FETCH_PROJECT_DATA, FETCH_PROJECT_SETTINGS } from "./actions.names";
import { API_URL } from "../global";
import axios from "axios";
import {
  SET_PROJECT_DATA,
  PROJECT_DATA_ERROR,
  SET_PROJECT_SETTINGS_ERROR,
  SET_PROJECT_SETTINGS,
} from "./mutations.names";

export const state: projectState = {
  data: [],
  error: false,
  settings: null,
  settingsError: false,
};

const namespaced: boolean = false;

const getters: GetterTree<projectState, RootState> = {
  projectList(state) {
    if (!state) {
      return undefined;
    }
    return Object.values(state.data as any);
  },

  [PROJECT_SETTINGS](state) {
    if (!state) {
      return undefined;
    }
    return state.settings;
  },

  projectCategoryList(state: any) {
    return [...new Set(state.data.map((p: any) => p.apartment_types))];
  },

  relatedProjects(state: any) {
    return (filter: RelatedProjectFilter) => {
      if (!state.data) {
        return [];
      }
      const existing: number[] = [];
      let data = state.data.filter((val: projectPageDataType) => {
        if (
          val.location === filter.location &&
          val.apartment_types === filter.type
        ) {
          existing.push(val.id);
          return true;
        }
        return false;
      });
      if (data.length >= 3) {
        return data;
      }
      data = data.concat(
        state.data.filter((val: projectPageDataType) => {
          if (
            val.location === filter.location &&
            existing.indexOf(val.id) === -1
          ) {
            existing.push(val.id);
            return true;
          }
          return false;
        })
      );
      if (data.length >= 3) {
        return data;
      }
      data = data.concat(
        state.data.filter((val: projectPageDataType) => {
          if (
            val.apartment_types === filter.type &&
            existing.indexOf(val.id) === -1
          ) {
            existing.push(val.id);
            return true;
          }
          return false;
        })
      );
      if (data.length >= 3) {
        return data;
      }

      data = data.concat(
        state.data.filter((val: projectPageDataType) => {
          return existing.indexOf(val.id) === -1;
        })
      );
      return data;
    };
  },
};

const actions: ActionTree<projectState, RootState> = {
  async [FETCH_PROJECT_DATA]({ commit }, id: number): Promise<any> {
    await axios
      .get(
        `${API_URL}/pages/?child_of=${id}&type=home.ProjectDetailsPage&fields=header_image_mobile,location,title,status,category_name`
      )
      .then(({ data }) => {
        commit(SET_PROJECT_DATA, data.items);
      })
      .catch((err: any) => {
        commit(PROJECT_DATA_ERROR);
      });
  },

  async [FETCH_PROJECT_SETTINGS]({ commit }): Promise<any> {
    await axios
      .get(`${API_URL}/others/settings/project/`)
      .then(({ data }) => {
        commit(SET_PROJECT_SETTINGS, data);
      })
      .catch((err: any) => {
        commit(SET_PROJECT_SETTINGS_ERROR);
      });
  },
};

const mutations: MutationTree<projectState> = {
  [SET_PROJECT_DATA](state, payload): any {
    state.data = payload;
    state.error = false;
  },
  [PROJECT_DATA_ERROR](state): any {
    state.data = [];
    state.error = true;
  },
  [SET_PROJECT_SETTINGS](state, payload): any {
    state.settings = payload;
    state.error = false;
  },
  [SET_PROJECT_SETTINGS_ERROR](state): any {
    state.settings = null;
    state.error = true;
  },
};

export const projectData: Module<projectState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
